<template>
  <q-page class="main">
    <common-form :action="$route('object.update', {object: object.id})" is-update>
      <q-card class="page-card">
        <q-card-section class="page-card__main-content">
          <h1 class="heading-2 q-mb-lg">{{ object.title }}</h1>
          <object-form :object="object" :object-groups="groups" :categories="categories"/>
        </q-card-section>
        <q-separator v-if="!object.deleted_at && $can('edit', object)"/>
        <q-card-actions align="between" class="q-pa-md">
          <warning-button v-if="!object.deleted_at && $can('edit', object)" label="Verwijder" @click="deleteObject" />
          <accent-button label="Opslaan" type="submit"/>
        </q-card-actions>
      </q-card>
      <sticky-top-bar />
    </common-form>
  </q-page>
</template>

<script>
import ObjectForm from './ObjectForm'

export default {
  components: {
    ObjectForm
  },
  props: {
    object: {
      type: Object,
      default: null
    },
    objects: {
      type: Object,
    },
    groups: {
      type: Object,
    },
    categories: {
      type: Object,
    },
  },
  methods: {
    async deleteObject() {
      if (!await this.$confirm(
          {
            title: 'Inrichtingselement verwijderen',
            messages: ['Weet u zeker dat u dit inrichtingselement wilt verwijderen?']
          }
      )) {
        return
      }
      this.$goto('object.destroy', {object: this.object.id});

    }
  },
}
</script>
